export default __webpack_public_path__ + "static/media/bg5.711b66d9.jpg";